import { Head } from '@inertiajs/react';
import { AppLayout } from '@/Layouts';
import { DashboardSection, PageProps, PaginatedResource, RecipeCollectionPreview, RecipePreview } from '@/types';
import { useTranslation } from 'react-i18next';
import { DashboardSectionType } from '@/enums';
import { RecipeCard, RecipeCollectionCard } from '@/Components/Specific';
import { UI } from '@/Components/UI';
import Logo from '@/../img/logo.svg';
import { useLocalizedRoute } from '@/hooks';

export default function({ dashboardItems }: PageProps<{ dashboardItems: PaginatedResource<DashboardSection> }>) {
    const { localizedRoute } = useLocalizedRoute();
    const { t } = useTranslation(['app']);

    return (
        <AppLayout activeItem={'home'}>
            <Head>
                <title>{t('dashboard')}</title>
                <meta name={'description'} content={t('description')} />
                <meta name="robots" content="index,follow" />
                <link rel={'canonical'} href={localizedRoute('home')} />
            </Head>

            <div className={'flex flex-col items-center gap-2'}>
                <img
                    src={Logo}
                    alt={import.meta.env.VITE_APP_NAME}
                    className={'md:hidden size-12'} />

                <h1 className={'font-baloo text-4xl font-semibold'}>
                    {import.meta.env.VITE_APP_NAME}
                </h1>
            </div>

            {dashboardItems.data
                .filter((item) => item.data != null)
                .map((item, index) => (
                    <div key={index}>
                        <UI.Heading level={2}>
                            {item.title}
                        </UI.Heading>

                        {item.type === DashboardSectionType.TEXT && (
                            <div>
                                <UI.Markdown children={item.data as string} />
                            </div>
                        )}

                        {item.type === DashboardSectionType.RECIPE_CAROUSEL && (
                            <div className={'grid grid-cols-2 gap-3 md:grid-cols-3'}>
                                {(item.data as RecipePreview[] | undefined)?.map((recipe: RecipePreview) => (
                                    <RecipeCard
                                        key={recipe.slug}
                                        recipe={recipe} />
                                ))}
                            </div>
                        )}

                        {item.type === DashboardSectionType.RECIPE_CARD && (
                            <div>
                                <RecipeCard
                                    recipe={item.data as RecipePreview} />
                            </div>
                        )}

                        {item.type === DashboardSectionType.COLLECTION_CAROUSEL && (
                            <div className={'grid grid-cols-2 gap-3 md:grid-cols-3'}>
                                {(item.data as RecipeCollectionPreview[] | undefined)?.map((collection: RecipeCollectionPreview) => (
                                    <RecipeCollectionCard
                                        key={collection.slug}
                                        collection={collection} />
                                ))}
                            </div>
                        )}
                    </div>
                ))}
        </AppLayout>
    );
}
